import { bemElement } from "utils/bem-class-names";
// @ts-ignore
import "./PrivacyPolicy.scss";
import { SvgIcon } from "elements/svg-icon/svg-icon";
import TocPrivacyPolicyFooter from "components/toc-privacypolicy-footer/TocPrivacyPolicyFooter";

const baseClassName = "privacy-policy";
const bem = bemElement(baseClassName);

const PrivacyPolicy = () => {
  return (
    <div className={baseClassName}>
      <div className={bem("title-container")}>
        <h3>Privacy Policy</h3>
        <div className={bem("last-updated")}>
          Effective Date: July 28, 2024{" "}
          <SvgIcon name="arrow_bottom" className={bem("arrow-icon")} />
        </div>
      </div>
      <section className={bem("contents")}>
        <article className={bem("content")}>
          <p>
            Pointment Inc. (“Company”, “we”, “us”, or “our”) respect the privacy
            of its users (“you”) and are committed to protecting it through our
            compliance with this Privacy Policy (“Policy”). This Policy
            describes:
            <br />
            <br />
            <ul className="list-disc ml-6">
              <li>
                The types of information we may collect or that you may provide
                when you purchase, access, or use the Services, as defined in
                Pointment’s Terms of Use.
              </li>
              <li>
                Our practices for collecting, using, maintaining, protecting,
                and disclosing that information.
              </li>
              <li>
                Your rights under the California Consumer Privacy Act of 2018,
                as amended by the California Privacy Rights Act.
              </li>
            </ul>
            <br />
            This Policy applies only to information we collect when providing
            the Services to you. This Policy DOES NOT apply to information that:
            We collect offline or on any other Company apps or websites; or you
            provide to or is collected by any third party. Other websites and
            apps as well as third parties may have their own privacy policies,
            which we encourage you to read before providing information on or
            through them.
            <br />
            <br />
            Please read this Policy carefully to understand our policies and
            practices regarding your information and how we will treat it. If
            you do not agree with this Policy or Terms of Use, do not purchase,
            access, or use the Services.
            <br />
            <br />
            Terms not defined herein have the meaning ascribed to such terms in
            Pointment’s Terms of Use.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">
              1. Information We Collect
            </h5>
            <br />
            We may collect information directly from you when you provide it to
            us or automatically when you use our Services. This information may
            include your real name, email address, postal address, phone number,
            IP address, biometric information, online identifier, account name,
            social security number, driver’s license number, passport number,
            characteristics of protected classifications under California or
            federal law, biometric information, geolocation data, professional
            or employment-related information, and education information. This
            information may also include: inferences drawn from any of the
            information we collect to create a profile about you reflecting your
            preferences, characteristics, psychological trends, predispositions,
            behavior, attitudes, intelligence, abilities, and aptitudes; and any
            other information that identifies, relates to, describes, is
            reasonably capable of being associated with, or could reasonably be
            linked, directly or indirectly, with a particular individual
            (collectively “Personal Information”).
            <br />
            <br />
            You may also provide information for publication or display
            (“Posted”) on public areas of the Website (collectively, “User
            Contributions”). Your User Contributions are Posted and transmitted
            to others at your own risk. Additionally, we cannot control the
            actions of third parties with whom you may choose to share your User
            Contributions. Therefore, we cannot and do not guarantee that your
            User Contributions will not be viewed by unauthorized persons.
            <br />
            <br />
            If you do not want us to collect your Personal Information or other
            information do not use the Services and you may opt out at any time
            by sending an email to{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>
            .
            <br />
            <br />
            We also may use the following technologies to collect information
            about your activities over time and across third-party websites,
            apps, or other online services:
            <br />
            <br />
            <ul className="list-disc ml-6">
              <li>
                Cookies. A cookie is a small file placed on your smartphone or
                computer. It may be possible to refuse to accept cookies by
                activating the appropriate setting on your smartphone or
                computer. However, if you select this setting you may be unable
                to access certain parts of our Services. For more information
                about how we use cookies, please see our{" "}
                <a
                  href="/cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie Policy
                </a>
                .
              </li>
              <li>
                Web Beacons. The Pointment Network (and our emails) may contain
                small electronic files known as web beacons (also referred to as
                clear gifs, pixel tags, and single-pixel gifs) that permit the
                Company, for example, to count users who have visited those
                pages (or opened an email) and for other related statistics.
              </li>
            </ul>
            <br />
            When you use the Services, including the Pointment Network, or their
            contents, certain third parties may use automatic information
            collection technologies to collect information about you or your
            device. These third parties may include: advertisers, ad networks,
            and ad servers; analytics companies; your mobile or computer device
            manufacturer; and/or your service provider. These third parties may
            use tracking technologies to collect information about you when you
            use the Services. The information they collect may be associated
            with your Personal Information or they may collect information,
            including Personal Information, about your online activities over
            time and across different websites, apps, and other online services
            websites. They may use this information to provide you with
            interest-based (behavioral) advertising or other targeted content.
            <br />
            <br />
            We do not control and will not be responsible or liable for these
            third parties tracking technologies or how they may be used. If you
            have any questions about an advertisement or other targeted content,
            you should contact the responsible provider directly.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">
              2. Use of Your Information
            </h5>
            <br />
            We use information that we collect about you or that you provide to
            us, including any Personal Information, to:
            <br />
            <br />
            <ul className="list-disc ml-6">
              <li>
                Provide you with the Services, including the Pointment Network,
                and their contents, and any other information, products, or
                services that you request from us;
              </li>
              <li>Fulfill any other purpose for which you provide it;</li>
              <li>
                Carry out our obligations and enforce our rights arising from
                any contracts entered into between you and us, including for
                billing and collection; and
              </li>
              <li>
                Notify you when updates are available, and of changes to any
                products or services we offer or provide.
              </li>
            </ul>
            <br />
            The usage information we collect helps us to improve our Services
            and to deliver a better and more personalized experience.
            <br />
            <br />
            We may also use your information to contact you about our own and
            third parties’ goods and services that may be of interest to you. If
            you do not want us to use your information in this way, please
            contact us at{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>
            .
            <br />
            <br />
            We may use the information we collect to display advertisements to
            our advertisers’ target audiences. Even though we do not disclose
            your Personal Information for these purposes without your consent,
            if you click on or otherwise interact with an advertisement, the
            advertiser may assume that you meet its target criteria.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">
              3. Sharing Your Information
            </h5>
            <br />
            We may use and disclose anonymized information about our users, and
            information that is not Personal Information, without restriction.
            <br />
            <br />
            In addition, we may disclose Personal Information that we collect,
            or you provide:
            <br />
            <br />
            <ul className="list-disc ml-6">
              <li>To our subsidiaries and affiliates;</li>
              <li>
                To contractors, service providers, and other third parties we
                use to support our business and who are bound by contractual
                obligations to keep Personal Information confidential and use it
                only for the purposes for which we disclose it to them;
              </li>
              <li>
                To a buyer or other successor in the event of a merger,
                divestiture, restructuring, reorganization, dissolution, or
                other sale or transfer of some or all of the Company’s assets,
                whether as a going concern or as part of bankruptcy,
                liquidation, or similar proceeding, in which Personal
                Information held by the Company is among the assets transferred;
              </li>
              <li>
                To third parties to market their products or services to you if
                you have not opted out of these disclosures
              </li>
              <li>To fulfill the purpose for which you provide it;</li>
              <li>
                For any other purpose disclosed by us when you provide the
                information;
              </li>
              <li>With your consent;</li>
              <li>
                To comply with any court order, law, or legal process, including
                to respond to any government or regulatory request;
              </li>
              <li>
                To enforce our rights arising from any contracts entered into
                between you and us, and for billing and collection; and
              </li>
              <li>
                If we believe disclosure is necessary or appropriate to protect
                the rights, property, or safety of the Company, our customers,
                or others.
              </li>
            </ul>
            <br />
            Text messaging originator opt-in data and consent will not be shared
            with any third parties, excluding aggregators and providers of the
            Text Message services.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">4. Your Rights</h5>
            <br />
            You have the following rights with respect to your Personal
            Information:
            <br />
            <br />
            <ul className="list-disc ml-6">
              <li>
                The right to know about the Personal Information that we collect
                about you and to know how it is used and shared;
              </li>
              <li>
                The right to delete Personal Information collected from you
                consistent with applicable law;
              </li>
              <li>
                The right to opt-out of the sale or sharing of your Personal
                Information;
              </li>
              <li>
                The right to non-discrimination in exercising your rights;
              </li>
              <li>
                The right to correct inaccurate Personal Information that we
                have about you; and
              </li>
              <li>
                The right to limit the use and disclosure of sensitive Personal
                Information collected about you.
              </li>
            </ul>
            <br />
            To exercise any of your data rights under applicable law, please
            contact us at{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>
            .
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">5. Data Security</h5>
            <br />
            We have implemented measures designed to secure your Personal
            Information from accidental loss and from unauthorized access, use,
            alteration, and disclosure. The safety and security of your
            information also depends on you. Where we have given you (or where
            you have chosen) a password for access to certain parts of our
            Services, you are responsible for keeping this password
            confidential. We ask you not to share your password with anyone.
            <br />
            <br />
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we do our best to protect your
            Personal Information, we cannot guarantee the security of your
            Personal Information transmitted through the Pointment Network. Any
            transmission of Personal Information is at your own risk.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">
              6. Changes to Our Privacy Policy
            </h5>
            <br />
            This Policy may change from time to time. Your continued use of the
            Services after we revise this Policy means you accept those changes.
            If we make material changes to how we treat our users’ Personal
            Information, we will post the new privacy policy on this page. The
            date the Policy was last revised is identified at the bottom of the
            page. You are responsible for ensuring we have an up-to-date active
            and deliverable email address for you and for periodically visiting
            this Policy to check for any changes.
          </p>
        </article>
        <article className={bem("content")}>
          <p>
            <h5 className="text-[16px] font-[500]">7. Contact Us</h5>
            <br />
            If you have any questions about this Policy or our privacy
            practices, please contact us at:{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>
          </p>
        </article>
        This Privacy Policy was last updated on July 28, 2024.
      </section>
      <TocPrivacyPolicyFooter />
    </div>
  );
};

export default PrivacyPolicy;
